import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useMockAuth } from '@/hooks/useMockAuth'
import { PATHS } from '@/routes/paths'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

export function PortalLayout() {
  const { isAuthenticated } = useMockAuth()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  if (!isAuthenticated) {
    return <Navigate to={PATHS.login} replace />
  }

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
